
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/watch/[project]/episode/[...friendlyPath]",
      function () {
        return require("private-next-pages/[locale]/watch/[project]/episode/[...friendlyPath].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/watch/[project]/episode/[...friendlyPath]"])
      });
    }
  